import { defineStyle } from '@chakra-ui/react';

export const filledVariant = defineStyle({
  background: 'neutral.900',
  color: 'neutral.white',
  border: '2px solid',
  borderColor: 'neutral.black',
  _hover: {
    borderColor: 'skyBlue',
    background: 'neutral.800',
    _disabled: {
      borderColor: 'neutral.black',
    },
  },
  _focus: {
    borderColor: 'skyBlue',
    background: 'neutral.800',
  },
  _invalid: {
    borderColor: 'red',
  },
  _readOnly: {
    cursor: 'default',
    _hover: {
      border: '2px solid',
      borderColor: 'neutral.black',
    },
  },
  _disabled: {
    cursor: 'default',
  },
});
